import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { AssignMeterService } from '../../service/assignmeter.service';
import { CommonService } from '../../service/common.service';
import { MatDialog } from '@angular/material/dialog';
import { SetParameterComponent } from '../set-parameter/set-parameter.component';
import { GSMConfigComponent } from '../gsmconfig/gsmconfig';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { SetparameterFlowmeterComponent } from '../setparameter-flowmeter/setparameter-flowmeter.component';
import { RegisterpanelComponent } from '../registerpanel/registerpanel';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
})
export class AddSiteComponent implements OnInit {
  // Property Declaration
  Registerdata: [];
  DeviceTypeList: [];
  AddSiteForm: FormGroup;
  errorMsg: string = '';
  SuccessMsg: string = '';
  RoleName: string = '';
  DisplayButton: boolean = true;
  SiteMasterList: [];
  GSMConfigId: [];
  minDate = new Date();
  lblparameter: string = '';
  windowheight: any;
  divHeight: number;
  tableHeight: number;
  ErrorMassage: string = '';
  lblSite: string = '';
  message: string = '';
  testIdFromFocus: string = '';
  initialSN: string[] = []; //  Mayank Dulera
  initialPN: string[] = []; //  Mayank Dulera
  initialEM: string[] = [];
  initialDN: string[] = [];
  EnergyMeterID: number;
  EnergyMeterGSMConfigID: number;
  DeviceTypeId: number;
  DeviceGSMConfigID: any;
  DeviceRTCConfigID: any;
  DeviceMQTConfigID: any;
  AllowedMachines: number;
  EMtoalLength: number = 0;
  IsreadOnly: boolean = false;
  // Called when window resize
  onResize() {
    this.ResizeHeight();
  }

  // Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 100;
    this.tableHeight = this.divHeight - 140;
  }

  constructor(
    private assignmeterservice: AssignMeterService,
    private commonservice: CommonService,
    private form: FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<SetParameterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
    if (data && data.SiteMasterList) {
      this.SiteMasterList = data.SiteMasterList;
    }

    if (data && data.AllowedMachines) {
      this.AllowedMachines = data.AllowedMachines;
    }
  }

  ngOnInit(): void {
    this.testIdFromFocus = '';
    this.ResizeHeight();
    this.RoleName = localStorage.getItem('RoleName');
    this.AddSiteForm = this.form.group({
      AddSiteArray: this.form.array([]),
    });

    if (this.RoleName == 'PortalAdmin') {
      this.lblparameter = 'View Parameter';
      this.IsreadOnly = true;
      this.lblSite = 'View Site';
    } else {
      this.lblparameter = 'Set Parameter';
      this.IsreadOnly = false;
      this.lblSite = 'Add Site';
    }

    this.initialEM = [];
    this.initialSN = []; //  Mayank Dulera
    this.initialPN = []; //  Mayank Dulera

    if (this.SiteMasterList) {
      this.SetSiteDetails();
    }
    this.getInitialEM();
    this.GetDeviceTypeList();
  }

  //  Set Site Details
  SetSiteDetails() {
    this.SiteMasterList.forEach((element, i) => {
      this.AddSiteRow(this.SiteMasterList[i], i);
    });
  }

  //  Add List Row
  AddSiteRow(Row, index) {
    const ArrSite = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    ArrSite.push(
      this.form.group({
        CompSiteId: Row && Row.CompSiteId ? Row.CompSiteId : 0,
        CompSiteName: Row && Row.CompSiteName ? Row.CompSiteName : '',
        //  Mayank Dulera
        Mode:
          Row && Row.Mode ? Row.Mode : Row && Row.CompSiteId ? 'Edit' : 'Add',
        ListPanelMasterBO: this.form.array([]),
      })
    );
    const ArrPanel = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(index)
      .get('ListPanelMasterBO') as FormArray;
    Row.ListPanelMasterBO.forEach((element, i) => {
      ArrPanel.push(this.PanelArray(element));
      // device // tathya
      const ArrDevice = (
        (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
          .at(index)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(i)
        .get('ListDevicetypeMasterBO') as FormArray;

      Row.ListPanelMasterBO[i].ListDevicetypeMasterBO.forEach((element, j) => {
        ArrDevice.push(this.DeviceArray(element));
        const ArrEnergy = (
          (
            (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
              .at(index)
              .get('ListPanelMasterBO') as FormArray
          )
            .at(i)
            .get('ListDevicetypeMasterBO') as FormArray
        )
          .at(j)
          .get('ListEnergymeterMasterBO') as FormArray;
        Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[
          j
        ].ListEnergymeterMasterBO.forEach((element, k) => {
          ArrEnergy.push(this.EnergyMeterArray(element));
        });
      });
    });
  }

  //  Add Panel Array
  PanelArray(lstPanel) {
    return this.form.group({
      Mode:
        lstPanel && lstPanel.Mode
          ? lstPanel.Mode
          : lstPanel && lstPanel.SitePanelId
          ? 'Edit'
          : 'Add',
      SitePanelId: lstPanel.SitePanelId,
      PanelName: lstPanel.PanelName,
      ListDevicetypeMasterBO: this.form.array([]),
    });
  }
  // Add device type Array
  DeviceArray(lstDevice) {
    return this.form.group({
      Mode:
        lstDevice && lstDevice.Mode
          ? lstDevice.Mode
          : lstDevice && lstDevice.DeviceTypeID
          ? 'Edit'
          : 'Add',
      DeviceTypeID: lstDevice.DeviceTypeID > 0 ? lstDevice.DeviceTypeID : 0,
      DeviceName: lstDevice.DeviceName,
      GSMDeviceConfigID: lstDevice.GSMDeviceConfigID,
      GSMConfigDataBO: lstDevice.GSMConfigDataBO,
      RTCSettingDataBO: lstDevice.RTCSettingDataBO,
      MQTTSettingDataBO: lstDevice.MQTTSettingDataBO,
      EthernetTcpSettingsBO: lstDevice.EthernetTcpSettingsBO,
      DeviceProtocol: lstDevice.DeviceProtocol,
      KeyID: lstDevice.KeyID,
      MaximumSlave: lstDevice.MaximumSlave,
      ListEnergymeterMasterBO: this.form.array([]),
    });
  }

  //  Add Energy Meter Array
  EnergyMeterArray(lstenergy) {
    return this.form.group({
      Mode:
        lstenergy && lstenergy.Mode
          ? lstenergy.Mode
          : lstenergy && lstenergy.EnergymeterMasterID
          ? 'Edit'
          : 'Add',
      EnergymeterMasterID: lstenergy.EnergymeterMasterID,
      EnergymeterID: lstenergy.EnergymeterID ? lstenergy.EnergymeterID : '',
      EnergymeterDesc: lstenergy.EnergymeterDesc,
      IsDisplay: lstenergy.IsDisplay ? lstenergy.IsDisplay : false,
      UnitRate: lstenergy.UnitRate,
      PowerFactorPenalty: lstenergy.PowerFactorPenalty,
      ThresholdEnergy: lstenergy.ThresholdEnergy,
      ThresholdTemperature: lstenergy.ThresholdTemperature,
      ThresholdHumidity: lstenergy.ThresholdHumidity,
      ThresholdMDI: lstenergy.ThresholdMDI,
      ThresholdPowerFactor: lstenergy.ThresholdPowerFactor,
      ThresholdElectricityBill: lstenergy.ThresholdElectricityBill,
      AnalogTemprature: lstenergy.AnalogTemprature,
      AnalogHumidity: lstenergy.AnalogHumidity,
      ValidToDate: lstenergy.ValidTo
        ? [formatDate(lstenergy.ValidTo, 'yyyy-MM-dd', 'en')][0]
        : lstenergy.ValidToDate
        ? [formatDate(lstenergy.ValidToDate, 'yyyy-MM-dd', 'en')][0]
        : '',
      DeviceTypeId: lstenergy.DeviceTypeId > 0 ? lstenergy.DeviceTypeId : 0,
      DeviceType: lstenergy.DeviceType,
      VaccumeTransmitter: lstenergy.VaccumeTransmitter,
      LowLevelTransmitter: lstenergy.LowLevelTransmitter,
      Calibration: lstenergy.Calibration,
      RegisterData: lstenergy.RegisterData,
    });
  }
  // Add Site
  AddSiteArray() {
    return this.form.group({
      //  Mayank Dulera
      CompSiteId: [0],
      CompSiteName: [''],
      EnergymeterMasterID: [0],
      SitePanelId: [0],
      Mode: ['Add'],
      ListPanelMasterBO: this.form.array([]),
    });
  }

  // Add Panel
  AddPanelArray() {
    return this.form.group({
      Mode: ['Add'], // Mayank
      PanelName: [''],
      SitePanelId: [0],
      ListDevicetypeMasterBO: this.form.array([]),
    });
  }
  // Add Device type // tathya
  AddDevicetypeArray() {
    return this.form.group({
      Mode: ['Add'],
      DeviceName: [''],
      DeviceId: [0],
      GSMConfigDataBO: [],
      RTCSettingDataBO: [],
      MQTTSettingDataBO: [],
      EthernetTcpSettingsBO: [],
      DeviceProtocol: [''],
      KeyID: [''],
      MaximumSlave: [0],
      ListEnergymeterMasterBO: this.form.array([]),
    });
  }
  // Add Energy Meter
  AddEnergyMeterArray() {
    return this.form.group({
      EnergymeterID: [''],
      EnergymeterMasterID: [0],
      Mode: ['Add'], // Mayank
      EnergymeterDesc: [''],
      IsDisplay: [false],
      ValidToDate: [''],
      UnitRate: [0.0],
      PowerFactorPenalty: [0.0],
      ThresholdEnergy: [0.0],
      ThresholdTemperature: [0.0],
      ThresholdHumidity: [0.0],
      ThresholdMDI: [0.0],
      ThresholdPowerFactor: [0.0],
      ThresholdElectricityBill: [0.0],
      AnalogTemprature: [0.0],
      AnalogHumidity: [0.0],
      DeviceTypeId: [''],
      DeviceType: [''],
      VaccumeTransmitter: [0.0],
      LowLevelTransmitter: [0.0],
      Calibration: [1.0],
      RegisterData: [],
    });
  }

  // Called on click Add Site
  AddSite() {
    const control = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    control.push(this.AddSiteArray());
  }

  // Called on click Add panel
  AddPanel(index) {
    const control = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(index)
      .get('ListPanelMasterBO') as FormArray;
    control.push(this.AddPanelArray());
  }
  // called on click add device type
  AddDevice(siteIndex, panelIndex) {
    const control = (
      (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    )
      .at(panelIndex)
      .get('ListDevicetypeMasterBO') as FormArray;
    control.push(this.AddDevicetypeArray());
  }

  // Called on click Add Energy Meter
  AddEnergyMeter(siteIndex, panelIndex, deviceIndex) {
    this.errorMsg = '';
    this.CheckMeterLength();
    const control = (
      (
        (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    )
      .at(deviceIndex)
      .get('ListEnergymeterMasterBO') as FormArray;
    var DeviceControl = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(deviceIndex);
    const EnergyMeterLength = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(siteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(panelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(deviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).length;

    if (this.EMtoalLength + 1 > this.AllowedMachines) {
      this.errorMsg = 'Total Meter count should be same as No of Machines.';
      return;
    }
    if (
      DeviceControl.get('GSMConfigDataBO').value != null &&
      DeviceControl.get('MQTTSettingDataBO').value != null
    ) {
      if (
        +DeviceControl.get('GSMConfigDataBO').value.MaximumSlave > 0 &&
        DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol != ''
      ) {
        if (
          EnergyMeterLength <
          DeviceControl.get('GSMConfigDataBO').value.MaximumSlave
        ) {
          control.push(this.AddEnergyMeterArray());
        } else {
          this.errorMsg = 'No. of Meter should be same as Maximum Slave !!';
        }
      } else {
        this.errorMsg =
          'Please configure Device' +
          siteIndex +
          1 +
          '.' +
          panelIndex +
          1 +
          '.' +
          deviceIndex +
          1 +
          ' first !!';
        return;
      }
    } else if (
      DeviceControl.get('MaximumSlave').value &&
      DeviceControl.get('MaximumSlave').value > 0 &&
      DeviceControl.get('DeviceProtocol').value &&
      DeviceControl.get('DeviceProtocol').value != ''
    ) {
      if (EnergyMeterLength < DeviceControl.get('MaximumSlave').value) {
        control.push(this.AddEnergyMeterArray());
      } else {
        this.errorMsg = 'No. of Meter should be same as Maximum Slave !!';
      }
    } else {
      this.errorMsg =
        'Please configure Device' +
        (siteIndex + 1) +
        '.' +
        (panelIndex + 1) +
        '.' +
        (deviceIndex + 1) +
        ' first !!';
      return;
    }
  }

  // Called on Delete Site icon
  DeleteSite(index) {
    const control = <FormArray>this.AddSiteForm.controls['AddSiteArray'];

    var CompSiteId = control.at(index).value.CompSiteId;

    if (CompSiteId > 0) {
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        index
      );
      SiteValues.get('Mode').patchValue('Delete');
    } else {
      control.removeAt(index);
    }
  }

  // Called on Delete Site icon
  DeletePanel(siteIndex, panelIndex) {
    const control = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(siteIndex)
      .get('ListPanelMasterBO') as FormArray;

    var PanelId = control.at(panelIndex).value.SitePanelId;
    if (PanelId > 0) {
      const PanelValues = (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      ).at(panelIndex);
      PanelValues.get('Mode').patchValue('Delete');
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        siteIndex
      );
      SiteValues.get('Mode').patchValue('Edit');
    } else {
      control.removeAt(panelIndex);
    }
  }
  // called on Delete Device//  tathya
  DeleteDeviceType(siteIndex, panelIndex, deviceIndex) {
    const control = (
      (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    )
      .at(panelIndex)
      .get('ListDevicetypeMasterBO') as FormArray;
    const DeviceTypeValues = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(deviceIndex);
    DeviceTypeValues.get('Mode').patchValue('Delete');
    const PanelValues = (
      (this.AddSiteForm.get('AddSiteArray') as FormArray)
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    ).at(panelIndex);
    PanelValues.get('Mode').patchValue('Edit');
    const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
      siteIndex
    );
    SiteValues.get('Mode').patchValue('Edit');
  }
  // Called on Delete EM icon
  DeleteEnergyMeter(siteIndex, panelIndex, deviceIndex, energyIndex) {
    const control = (
      (
        (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    )
      .at(deviceIndex)
      .get('ListEnergymeterMasterBO') as FormArray;
    var EmeterId = control.at(energyIndex).value.EnergymeterMasterID;
    if (EmeterId > 0) {
      const EnergyMeterValues = (
        (
          (
            (this.AddSiteForm.get('AddSiteArray') as FormArray)
              .at(siteIndex)
              .get('ListPanelMasterBO') as FormArray
          )
            .at(panelIndex)
            .get('ListDevicetypeMasterBO') as FormArray
        )
          .at(deviceIndex)
          .get('ListEnergymeterMasterBO') as FormArray
      ).at(energyIndex);
      EnergyMeterValues.get('Mode').patchValue('Delete');
      const DeviceTypeValues = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(siteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(panelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      ).at(deviceIndex);
      DeviceTypeValues.get('Mode').patchValue('Edit');
      const PanelValues = (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      ).at(panelIndex);
      PanelValues.get('Mode').patchValue('Edit');
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        siteIndex
      );
      SiteValues.get('Mode').patchValue('Edit');
    } else {
      control.removeAt(energyIndex);
    }
  }
  // Open Set Parameter Popup device type // tathya
  OpenSetPopup(SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
    const EnergyMeterValues = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);

    const Setparamdialogref = this.dialog.open(SetParameterComponent, {
      width: '730px',
      height: '470px',
      data: {
        SiteMasterList: EnergyIndex,
      },
    });
    Setparamdialogref.afterClosed().subscribe((result) => {});
  }
  //  Open Set Parameter Popup
  OpenSetParamPopup(SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
    this.errorMsg = '';
    const EnergyMeterValues = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);

    var DeviceTypeId = EnergyMeterValues.get('DeviceTypeId').value;

    var DeviceType = EnergyMeterValues.get('DeviceType').value;

    if (DeviceTypeId > 0) {
      if (DeviceType == 'EnergyMeter') {
        const Setparamdialogref = this.dialog.open(SetParameterComponent, {
          width: '730px',
          height: '470px',
          data: {
            SiteMasterList: EnergyMeterValues.value,
          },
        });

        // Callback method of popup close
        Setparamdialogref.afterClosed().subscribe((result) => {
          if (result) {
            //
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(SiteIndex)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(PanelIndex)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(DeviceIndex)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(EnergyIndex);
            EnergyMeterValues.get('UnitRate').patchValue(
              result.UnitRate ? result.UnitRate : 0
            );
            EnergyMeterValues.get('PowerFactorPenalty').patchValue(
              result.PowerFactorPenalty ? result.PowerFactorPenalty : 0
            );
            EnergyMeterValues.get('ThresholdEnergy').patchValue(
              result.ThresholdEnergy ? result.ThresholdEnergy : 0
            );
            EnergyMeterValues.get('ThresholdTemperature').patchValue(
              result.ThresholdTemperature ? result.ThresholdTemperature : 0
            );
            EnergyMeterValues.get('ThresholdHumidity').patchValue(
              result.ThresholdHumidity ? result.ThresholdHumidity : 0
            );
            EnergyMeterValues.get('ThresholdPowerFactor').patchValue(
              result.ThresholdPowerFactor ? result.ThresholdPowerFactor : 0
            );
            EnergyMeterValues.get('ThresholdElectricityBill').patchValue(
              result.ThresholdElectricityBill
                ? result.ThresholdElectricityBill
                : 0
            );
            EnergyMeterValues.get('ThresholdMDI').patchValue(
              result.ThresholdMDI ? result.ThresholdMDI : 0
            );
            EnergyMeterValues.get('AnalogTemprature').patchValue(
              result.AnalogTemprature ? result.AnalogTemprature : 0
            );
            EnergyMeterValues.get('AnalogHumidity').patchValue(
              result.AnalogHumidity ? result.AnalogHumidity : 0
            );
            EnergyMeterValues.get('VaccumeTransmitter').patchValue(
              result.VaccumeTransmitter ? result.VaccumeTransmitter : 0
            );
            EnergyMeterValues.get('LowLevelTransmitter').patchValue(
              result.LowLevelTransmitter ? result.LowLevelTransmitter : 0
            );
            EnergyMeterValues.get('Calibration').patchValue(
              result.Calibration ? result.Calibration : 0
            );
          }
        });
      } else {
        const Setparamdialogref = this.dialog.open(
          SetparameterFlowmeterComponent,
          {
            width: '500px',
            height: '350px',
            data: {
              SiteMasterList: EnergyMeterValues.value,
              IsfromAddSite: true,
            },
          }
        );

        // Callback method of popup close
        Setparamdialogref.afterClosed().subscribe((result) => {
          if (result) {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(SiteIndex)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(PanelIndex)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(DeviceIndex)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(EnergyIndex);
            EnergyMeterValues.get('VaccumeTransmitter').patchValue(
              result.VaccumeTransmitter ? result.VaccumeTransmitter : 0
            );
            EnergyMeterValues.get('LowLevelTransmitter').patchValue(
              result.LowLevelTransmitter ? result.LowLevelTransmitter : 0
            );
            EnergyMeterValues.get('Calibration').patchValue(
              result.Calibration ? result.Calibration : 0
            );
          }
        });
      }
    } else {
      this.errorMsg = 'Please select Device Type first!!';
    }
  }

  getInitialEM() {
    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      //  Mayank Dulera
      const SiteNameValues = (
        this.AddSiteForm.get('AddSiteArray') as FormArray
      ).at(i);
      var sname = SiteNameValues.get('CompSiteName').value;
      this.initialSN.push(sname);
      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        //  Mayank Dulera
        const PanelNameValues = (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        ).at(j);
        var pname = PanelNameValues.get('PanelName').value;
        this.initialPN.push(pname);

        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const DeviceTypeValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(k);
          var DeviceId = DeviceTypeValues.get('DeviceName').value;
          this.initialDN.push(DeviceId);

          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          EnergyMeterArray.value.forEach((element, l) => {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(i)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(j)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(k)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(l);
            var EMId = EnergyMeterValues.get('EnergymeterID').value;
            this.initialEM.push(EMId);
          });
        });
      });
    });
  }

  // Called on Save button click //  Mayank Dulera
  SaveSite() {
    this.ErrorMassage = '';
    var EMIdArrInSave = [];
    var SiteNameInSave = [];
    var PanelNameInSave = [];
    var DeviceTypeInSave = [];

    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      const SiteNameValues = (
        this.AddSiteForm.get('AddSiteArray') as FormArray
      ).at(i);
      var sname = SiteNameValues.get('CompSiteName').value;

      // Sweta Jain : Remove from SiteArray when SiteName is null or blank
      if (sname == '' || sname == null) {
        SiteArray.removeAt(i);
      }

      SiteNameInSave.push(sname);
      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        const PanelValues = (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        ).at(j);
        var pname = PanelValues.get('PanelName').value;
        PanelNameInSave.push(pname);
        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const DeviceTypeValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(k);

          var dname = DeviceTypeValues.get('DeviceName').value;
          DeviceTypeInSave.push(dname);
          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;

          EnergyMeterArray.value.forEach((element, l) => {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(i)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(j)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(k)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(l);
            var UnitRate = EnergyMeterValues.get('UnitRate').value;
            var PFP = EnergyMeterValues.get('PowerFactorPenalty').value;
            var EMId = EnergyMeterValues.get('EnergymeterID').value;
            var DeviceType = EnergyMeterValues.get('DeviceType').value;
            EMIdArrInSave.push(EMId);
            if (SiteNameValues.value.CompSiteId != null) {
              if (
                SiteNameValues.value.Mode === 'Delete' ||
                PanelValues.value.Mode === 'Delete'
              ) {
                PanelValues.value.Mode = 'Delete';
                EnergyMeterValues.value.Mode = 'Delete';
              }
            }
            if (PanelValues.value.PanelId != null) {
              if (PanelValues.value.Mode === 'Delete') {
                DeviceTypeValues.value.Mode = 'Delete';
              }
            }
            if (DeviceTypeValues.value.DeviceId != null) {
              if (DeviceTypeValues.value.Mode === 'Delete') {
                EnergyMeterValues.value.Mode = 'Delete';
              }
            }
            if (DeviceType == 'EnergyMeter') {
              if (+UnitRate == 0 && +PFP == 0 && EMId != '') {
                this.ErrorMassage = this.ErrorMassage + EMId + ',';
              }
            }
          });
        });
      });
    });

    if (this.ErrorMassage) {
      this.ErrorMassage =
        'Unit Rate and Power Factor Penalty are required for ' +
        this.ErrorMassage;
      this.errorMsg = this.ErrorMassage.replace(/,\s*$/, '');
      return;
    }
    //  Mayank Dulera
    let findDuplicates = (arr) =>
      arr.filter((item, index) => arr.indexOf(item) != index);

    if (findDuplicates(SiteNameInSave).length) {
      this.errorMsg = 'Site already exist!!';
      return;
    } else if (findDuplicates(EMIdArrInSave).length) {
      this.errorMsg = 'MeterID already exist!!';
      return;
    }

    // Sweta Jain : Duplicate Panel Name Validation
    else if (findDuplicates(PanelNameInSave).length) {
      this.errorMsg = 'Location Name already exist!!';
      return;
    } else {
      this.dialogRef.close(SiteArray.value);
    }
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }

  // called on cancel button
  OnCancel() {
    this.dialogRef.close();
  }

  onFocusOutEvent(event: any) {
    var EMIdArr = [];
    var SiteName = []; // Mayank Dulera
    var PanelName = []; // Mayank Dulera
    var DeviceType = [];

    this.testIdFromFocus = event.target.value;

    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      // Mayank Dulera
      const SiteNameValues = (
        this.AddSiteForm.get('AddSiteArray') as FormArray
      ).at(i);
      var sname = SiteNameValues.get('CompSiteName').value;
      SiteName.push(sname);

      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        // Mayank Dulera
        const PanelNameValues = (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        ).at(j);
        var pname = PanelNameValues.get('PanelName').value;
        PanelName.push(pname);

        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const DeviceTypeValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(k);
          var dname = DeviceTypeValues.get('DeviceName').value;
          DeviceType.push(dname);
          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          EnergyMeterArray.value.forEach((element, l) => {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(i)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(j)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(k)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(l);
            var UnitRate = EnergyMeterValues.get('UnitRate').value;
            var PFP = EnergyMeterValues.get('PowerFactorPenalty').value;
            var EMId = EnergyMeterValues.get('EnergymeterID').value;
            EMIdArr.push(EMId);
            if (+UnitRate == 0 && +PFP == 0 && EMId != '') {
              this.ErrorMassage = this.ErrorMassage + EMId + ',';
            }
          });
        });
      });
    });
    // Mayank Dulera
    let findDuplicates = (arr) =>
      arr.filter((item, index) => arr.indexOf(item) != index);

    if (findDuplicates(SiteName).length) {
      this.errorMsg = 'SiteName already exist!!';
      return;
    } else if (JSON.stringify(SiteName) == JSON.stringify(this.initialSN)) {
      this.errorMsg = '';
    } else {
      this.errorMsg = '';
      this.CheckNameExist('Site', this.testIdFromFocus);
    }

    if (findDuplicates(PanelName).length) {
      this.errorMsg = 'PanelName already exist!!';
      return;
    } else if (JSON.stringify(PanelName) == JSON.stringify(this.initialPN)) {
      this.errorMsg = '';
    } else {
      this.errorMsg = '';
      this.CheckNameExist('Panel', this.testIdFromFocus);
    }

    if (findDuplicates(EMIdArr).length) {
      this.errorMsg = 'MeterID already exist!!';
    } else if (JSON.stringify(EMIdArr) == JSON.stringify(this.initialEM)) {
      this.errorMsg = '';
    } else {
      this.errorMsg = '';
      this.CheckNameExist('EnergyMeter', this.testIdFromFocus);
    }
  }

  // Get Device Type List
  GetDeviceTypeList() {
    this.commonservice.GetDeviceTypeList().subscribe(
      (result) => {
        this.DeviceTypeList = result;
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // On Change Device Type
  OnChangeDeviceType(event, SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
    this.errorMsg = '';
    const EMValues = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);
    if (event.value > 0) {
      EMValues.get('DeviceTypeId').patchValue(event.value);
      EMValues.get('DeviceType').patchValue(event.source.triggerValue);
    }
  }

  OnConfigRegister(SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
    this.errorMsg = '';
    var DeviceControl = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(SiteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(PanelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(DeviceIndex);

    if (DeviceControl.get('GSMConfigDataBO').value) {
      if (DeviceControl.get('GSMConfigDataBO').value.KeyID) {
        DeviceControl.get('KeyID').patchValue(
          DeviceControl.get('GSMConfigDataBO').value.KeyID
        );
      }
    }

    if (DeviceControl.get('GSMConfigDataBO').value) {
      if (DeviceControl.get('GSMConfigDataBO').value.dtype) {
        DeviceControl.get('dtype').patchValue(
          DeviceControl.get('GSMConfigDataBO').value.dtype
        );
      }
    }

    if (DeviceControl.get('MQTTSettingDataBO').value) {
      if (DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol) {
        if (DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol == 0) {
          DeviceControl.get('DeviceProtocol').patchValue('HTTP');
        } else if (
          DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol == 1
        ) {
          DeviceControl.get('DeviceProtocol').patchValue('FTP');
        }
      }
    }

    // For Get DeviceProtocol Value

    var DeviceProtocol = DeviceControl.get('DeviceProtocol').value;
    var KeyID = DeviceControl.get('KeyID').value;

    const EnergyMetervalues = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);

    try {
      this.EnergyMeterID = EnergyMetervalues.value.EnergymeterMasterID;
    } catch (e) {
      this.EnergyMeterID = 0;
    }

    if (this.EnergyMeterID == null) {
      this.EnergyMeterID = 0;
    }
    if (DeviceProtocol && KeyID) {
      const Setparamdialogref = this.dialog.open(RegisterpanelComponent, {
        width: '3000px',
        height: '500px',
        data: {
          EnergyMeterdata: {
            EMID: this.EnergyMeterID,
            RegisterData: EnergyMetervalues.get('RegisterData').value,
            DeviceProtocol: DeviceProtocol,
            EMIndex: EnergyIndex,
            KeyID: KeyID,
          },
        },
      });

      Setparamdialogref.afterClosed().subscribe((result) => {
        if (result != undefined) {
          const EnergyMetervalues = (
            (
              (
                (this.AddSiteForm.get('AddSiteArray') as FormArray)
                  .at(SiteIndex)
                  .get('ListPanelMasterBO') as FormArray
              )
                .at(PanelIndex)
                .get('ListDevicetypeMasterBO') as FormArray
            )
              .at(DeviceIndex)
              .get('ListEnergymeterMasterBO') as FormArray
          ).at(EnergyIndex);
          EnergyMetervalues.get('RegisterData').patchValue(result);
        }
      });
    } else {
      this.errorMsg =
        'Please select Device Type first from Device Settings Tab.';
      return;
    }
  }

  // open configpopup
  OnConfig(SiteIndex, PanelIndex, DeviceIndex) {
    this.errorMsg = '';
    const DeviceValue = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(SiteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(PanelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(DeviceIndex);

    try {
      this.DeviceGSMConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; // GSMDeviceConfigID
    } catch (e) {
      this.DeviceGSMConfigID = 0;
    }
    try {
      this.DeviceRTCConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; // RTCDeviceConfigID
    } catch (e) {
      this.DeviceRTCConfigID = 0;
    }
    try {
      this.DeviceMQTConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; // GSMDeviceConfigID
    } catch (e) {
      this.DeviceMQTConfigID = 0;
    }
    try {
      this.DeviceTypeId = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('DeviceTypeID').value;
    } catch (e) {
      this.DeviceTypeId = 0;
    }

    if (this.DeviceGSMConfigID == null) {
      this.DeviceGSMConfigID = 0;
    }
    if (this.EnergyMeterID == null) {
      this.EnergyMeterID = 0;
    }

    if (DeviceValue.value.DeviceName) {
      const Setparamdialogref = this.dialog.open(GSMConfigComponent, {
        width: '730px',
        height: '515px',
        data: {
          GSMConfigAllData: {
            DeviceTypeID: this.DeviceTypeId,
            DeviceName: DeviceValue.value.DeviceName,
            DeviceGSMID: this.DeviceGSMConfigID,
            DeviceRTCID: this.DeviceRTCConfigID,
            DeviceMQTID: this.DeviceMQTConfigID,
            DeviceGSMData: DeviceValue.get('GSMConfigDataBO').value,
            DeviceRTCData: DeviceValue.get('RTCSettingDataBO').value,
            DeviceMQTData: DeviceValue.get('MQTTSettingDataBO').value,
            EthernetTcpSettingsBO: DeviceValue.get('EthernetTcpSettingsBO')
              .value,
          },
        },
      });

      // Callback method of popup close
      Setparamdialogref.afterClosed().subscribe((result) => {
        if (result) {
          const DeviceValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(SiteIndex)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(PanelIndex)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(DeviceIndex);
          if (result) {
            if (result.TabValue == 'Configuration') {
              DeviceValues.get('GSMConfigDataBO').patchValue(result);
            } else if (result.TabValue == 'RTC') {
              DeviceValues.get('RTCSettingDataBO').patchValue(result);
            } else if (result.TabValue == 'Settings') {
              DeviceValues.get('MQTTSettingDataBO').patchValue(result);
            } else if (result.TabValue == 'Ethernet Settings') {
              DeviceValues.get('EthernetTcpSettingsBO').patchValue(result);
            }
          }
        }
      });
    } else {
      this.errorMsg = 'Please enter Device Name first!!';
      return;
    }
  }

  // Check Site, Panel, Meter Name Exist
  CheckNameExist(Type, value) {
    if (value != '') {
      this.assignmeterservice.CheckEnergyMeterExist(Type, value).subscribe(
        (result) => {
          this.message = result.Response;
          if (Type == 'Site') {
            if (this.message == 'Site already exist') {
              this.errorMsg = 'Site already exist!!';
            } else if (Type == 'Panel') {
              this.errorMsg = 'PanelName already exist!!';
            } else if (Type == 'EnergyMeter') {
              this.errorMsg = 'Meter already exist!!';
            }
          } else {
            this.errorMsg = '';
          }
        },
        (error) => {
          this.errorMsg = `service failure ${error}`;
        }
      );
    }
  }

  CheckMeterLength() {
    this.EMtoalLength = 0;
    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          this.EMtoalLength = this.EMtoalLength + EnergyMeterArray.length;
        });
      });
    });
  }
}
